import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { I18NextModule } from 'angular-i18next';

import { StorageService } from 'src/app/core/storage/storage.service';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User } from 'src/app/shared/model/user.model';
import {
  FunctionType,
  NewRequestForm,
  OrderRequest,
  ReplacementVehicleRequest
} from 'src/app/shared/model/order.model';

import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { PccVehicle } from 'src/app/shared/model/vehicle.model';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { GenerateNewOrderObj } from 'src/app/shared/utils/generateNewOrderObj';
import { DeliveryLocation } from 'src/app/shared/model/location.enum';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import i18next from 'i18next';
import { CoreService } from 'src/app/core/services/core.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-function-request',
  templateUrl: './function-request.component.html',
  styleUrls: ['./function-request.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    StepperComponent,
    ModalConfirmRequestComponent,
    FeedbackModalComponent
  ]
})
export class FunctionRequestComponent implements OnInit, AfterViewInit {
  user!: User;
  requestType = RequestType.function;
  requestSubtype = '';
  requestForm?: NewRequestForm;
  retribution!: string;
  replacementVehicle?: ReplacementVehicleRequest | null;
  requestObj!: OrderRequest;

  locationMartorell = false;

  steps = new Map<string, boolean>();
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    private generateNewOrderObj: GenerateNewOrderObj,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('approvers', true);
    this.steps.set('request-info', true);
    this.steps.set('car-config', true);
    this.steps.set('replacementvehicle', true);
    this.steps.set('additionalInfo', true);
  }

  generateRequestObject(newRequestData: any) {
    this.locationMartorell =
      newRequestData.requestInfo?.deliveryLocationChecked;

    const orderInfo = {
      requestType: 'FUNCTION',
      comments: newRequestData.comments,
      controllerUserId: newRequestData.controller?.id,
      delegatedApproverUserId: newRequestData.authorizer?.id
    };

    let newVehicle: PccVehicle | null = null;
    let stockVehicle: any;

    if (newRequestData.vehicleInfo?.type === 'configurator') {
      newVehicle = {
        ...newRequestData.vehicleInfo?.data,
        configCode: newRequestData.vehicleInfo?.configCode
      };
    } else if (newRequestData.vehicleInfo?.type === 'stock') {
      stockVehicle = {
        VIN: newRequestData.vehicleInfo?.data.VIN
      };
    }

    const phone = newRequestData.extraPhone.trim();
    const email = newRequestData.extraEmail.trim();

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    let functionClass: string;
    if (newRequestData.requestInfo?.class === 'Comité ejecutivo') {
      functionClass = 'SCE';
    } else if (newRequestData.requestInfo?.class === 'Delegado zona') {
      functionClass = 'DZ';
    } else if (newRequestData.requestInfo?.class === 'Delegado sindical') {
      functionClass = 'DS';
    } else {
      functionClass = '';
    }
    if (this.locationMartorell) {
      const functionData: FunctionType = {
        orderSubType:
          newRequestData.requestInfo?.subtype === 'SUBSTITUTION'
            ? 'SUBSTITUTION'
            : 'FIRST_ASSIGNMENT',
        functionClass: functionClass,
        differentRequesterUserId: this.requestForm?.nis
          ? this.requestForm.nis
          : '',
        retribution: newRequestData.retribution,
        newVehicle:
          newVehicle === null
            ? null
            : this.generateNewOrderObj.mapNewVehicle(newVehicle),
        stockVehicle: stockVehicle,
        replacedVehicle:
          newRequestData.replacementVehicleInfo === null
            ? null
            : newRequestData.replacementVehicleInfo,
        deliveryLocation: DeliveryLocation.MARTORELL,
        checkMartorell: newRequestData.requestInfo?.checkMartorell
      };
      this.requestObj = {
        orderInfo: { ...orderInfo },
        functionData: { ...functionData },
        contactInfoDataDTO: { ...contactInfoDataDTO }
      };
    } else {
      const functionData: FunctionType = {
        orderSubType:
          newRequestData.requestInfo?.subtype === 'SUBSTITUTION'
            ? 'SUBSTITUTION'
            : 'FIRST_ASSIGNMENT',
        functionClass: functionClass,
        differentRequesterUserId: this.requestForm?.nis
          ? this.requestForm.nis
          : '',
        retribution: newRequestData.retribution,
        newVehicle:
          newVehicle === null
            ? null
            : this.generateNewOrderObj.mapNewVehicle(newVehicle),
        stockVehicle: stockVehicle,
        replacedVehicle:
          newRequestData.replacementVehicleInfo === null
            ? null
            : newRequestData.replacementVehicleInfo,
        deliveryLocation: null,
        checkMartorell: newRequestData.requestInfo?.checkMartorell
      };
      this.requestObj = {
        orderInfo: { ...orderInfo },
        functionData: { ...functionData },
        contactInfoDataDTO: { ...contactInfoDataDTO }
      };
    }
  }

  openConfirmationModal() {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.coreService.newOrder(this.requestObj).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              redirect: false,
              cancelRequest: false,
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.generateRequestObject(newRequestData);
    this.openConfirmationModal();
  }
}
